import './styles.scss';

import React from 'react';

import cn from 'classnames';

export const SpaceVertical = ({ multiplier }) => <div className={cn('space-vertical', multiplier)} />;
export const SpaceHorizontal = ({ multiplier }) => <div className={cn('space-horizontal', multiplier)} />;
